module.exports = __webpack_public_path__ + "static/media/feature-recommedation@2x.27ac3880.png";